$(function() {
    $('.js-open-view-nav, .js-close-view-nav').on('click', function () {
        $('.hidden-block').toggleClass('hidden-block-active');
        $('.js-open-view-nav, .js-close-view-nav').toggleClass('visible-print');

        if ($('.hidden-block').hasClass('hidden-block-active')) {
            $('.information-tab .order-mobile-2').css('z-index', '0')
        } else {
            $('.information-tab .order-mobile-2').css('z-index', '2')
        }
        
        $('.legend').removeClass('legend-active')
        $('.legend').removeClass('active-top')
    })

    $('#map-form input').on('change', function () {
        if ($('input[name=view]:checked', '#map-form').val() == "draw-view") {
            $('.checkbox--hidden').removeClass('visible-print');
        } else {
            $('.checkbox--hidden').addClass('visible-print');
        }
    });

});